var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97803 7.8985C12.509 4.67074 17.1264 2.93368 21.8259 2.55469C26.5254 2.66207 31.326 4.15278 34.9138 7.38054C33.3473 8.76387 32.0209 10.4441 30.3217 11.6948C25.5716 7.57004 17.7959 7.98062 13.3617 12.3706C11.8773 10.9052 10.3866 9.43974 8.98434 7.89218L8.97803 7.8985Z",
    fill: "#7550FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17068 30.0831C1.75775 24.0634 2.39572 16.6856 6.24251 11.4492C9.5587 14.8412 12.9065 18.2269 16.2732 21.5368C18.743 19.446 20.8148 16.7362 23.3604 14.7591C25.7481 16.9825 27.9525 19.3702 30.3402 21.5936C31.8814 19.9955 33.4732 18.448 35.0903 16.9257C34.4017 16.0287 33.549 15.2707 32.81 14.4559C35.8103 14.4812 38.8107 14.4559 41.8048 14.4559V23.596C41.0594 22.8632 40.3962 22.0231 39.575 21.3725C39.095 21.3157 38.8612 21.8905 38.5138 22.1305C35.7535 24.8719 33.0753 27.7712 30.2076 30.4052C27.9273 28.0997 25.6154 25.7941 23.2783 23.5139C20.9664 25.7941 18.6356 28.0997 16.4311 30.4558C13.7782 28.2323 11.5737 25.4404 8.92073 23.217C9.05338 27.2596 10.9673 31.0306 14.1508 33.4435C18.7935 37.2145 25.8807 37.1071 30.555 33.4182C32.0394 34.7763 33.3406 36.3491 34.8565 37.7009C34.3512 38.541 33.5048 38.9768 32.7342 39.4884C30.555 40.8149 28.1673 41.8193 25.647 42.173C23.632 42.2804 21.6107 42.1982 19.5957 42.2804C12.8307 41.3834 6.6973 36.5576 4.17699 30.0768L4.17068 30.0831Z",
    fill: "#7550FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinw);
export default __webpack_public_path__ + "static/media/coinw.6bd65dbd312ea25d929536fa5ce14185.svg";
export { ForwardRef as ReactComponent };